/**
 * Generates link for templated pages (eg. resource detail page, blog post, etc.)
 */

import React, { useContext } from 'react'
import { ConfigContext } from 'components/context/ConfigProvider'
import templateURL from './templateURL'
import BasicLink from '../BasicLink'

interface TemplateLinkProps {
  data: any
  openInNewTab?: boolean
  className?: string
  children: React.ReactNode
}

const TemplateLink = ({
  data,
  openInNewTab = false,
  className,
  children,
}: TemplateLinkProps): JSX.Element => {
  const config = useContext(ConfigContext)

  if (!config) {
    throw new Error('Config is null or undefined from ConfigContext.')
  }

  const resourceUrlTemplate = config.siteMap.detail.urlTemplate

  if (!resourceUrlTemplate) {
    throw new Error('No urlTemplate found on siteMap.detail')
  }
  return (
    <BasicLink
      className={className}
      openInNewTab={openInNewTab}
      url={templateURL(data, resourceUrlTemplate)}
    >
      {children}
    </BasicLink>
  )
}
export default TemplateLink
